import { getYearsOfExperience } from "../about.api";

export default function AboutMeContents() {
    return (
        <>
            <p>Hi, my name is Ajay Bhattacharyya. I am a Software Engineer at Excellus BCBS, based out of Rochester, NY. I have Bachelor's degrees in Computer Science and Mathematics from SUNY Brockport, where my AI research was featured in Human-Computer Interaction International (HCII).</p>
            <p>I am passionate about designing and developing full-stack web applications and applied AI systems, and I have {getYearsOfExperience()} years of experience implementing solutions for companies in the health insurance, cybersecurity, and supply chain management industries.</p>
            <p>In addition to my work in the industry, I also maintain several open source projects. Be sure to check out the Projects page to learn more!</p>
        </>
    )
}